import { ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useRouteMatch } from "react-router-dom";

import { ShiftInvitesPage } from "./Page";
import { ShiftInviteModalRoutes } from "./ShiftInviteModalRoutes";

/**
 * ShiftInvitesRouteContainer combines the shift invites page with its modal routes.
 *
 * This follows the same pattern as DocumentsContainer and other route containers
 * that need to render both the main page and any associated modal routes.
 */
export function ShiftInvitesRouteContainer() {
  const match = useRouteMatch();

  return (
    <ThemeProvider theme={getTheme()}>
      <ShiftInvitesPage />
      <ShiftInviteModalRoutes basePath={match.url} />
    </ThemeProvider>
  );
}
